import {Component, Input} from "@angular/core";

@Component({
    selector: "fui-panels-alert",
    styleUrls: ["./panels-alert.component.scss"],
    templateUrl: "./panels-alert.component.html",
    standalone: false
})
export class FUIPanelsAlertComponent {
    @Input() description: string;
    @Input() title: string;
}
